import { Dispatch, SetStateAction, useEffect, useState } from "react";
import API from "../api";
import CommonButton from "../components/CommonButton";
import { AxiosResponse } from "axios";
import CommonTable from "../components/CommonTable";
import style from "../style/twoColForm.module.scss";
import btnStyle from "../style/btn.module.scss";
import { Input, Space, Switch, TableProps, message, Select } from "antd";
import { CreatePartnerInterface, MODE } from "./partnersConst";
import PartnerHubs from "../components/partnerHubs";
import SearchFeature from "../partner/SearchFeture";
import { AllowInputType, isValidEmail } from "../utils/ValidationReg";
import { stateCityData, states } from "./stateCityData";

function CreateEditParnter({
  mode,
  setMode,
  data,
}: {
  mode: MODE.EDIT_PARTNER | MODE.CREATE_PARTNER;
  setMode: Dispatch<SetStateAction<MODE>>;
  data: CreatePartnerInterface;
}) {
  const [apiData, setApiData] = useState(data);
  const [errors, setErrors] = useState<any>({});
  const [availableCities, setAvailableCities] = useState<string[]>([]);
  const savePartner = async () => {
    let partner;
    if (!validateForm()) {
      message.error("Please fill all required fields.");
      return; // Stop if validation fails
    }

    if (mode === MODE.CREATE_PARTNER)
      partner = await API.admin.CreatePartner(apiData);
    if (mode === MODE.EDIT_PARTNER)
      partner = await API.admin.EditPartner(apiData, apiData._id);

    if (!API.validators.checkSuccessCode(partner as AxiosResponse<any, any>))
      return message.error("unable to create/Modify partner try again");

    message.success("Partner creation successful");

    setMode(MODE.HOME);
  };
  const validateForm = () => {
    const newErrors: any = {};
    if (!apiData.contactPerson)
      newErrors.contactPerson = "Partner person is required.";
    if (!apiData.name) newErrors.name = "Company name is required.";
    if (!apiData.accountNumber)
      newErrors.accountNumber = "Bank account number is required.";
    if (!apiData.ifsc) newErrors.ifsc = "IFSC code is required.";
    if (!apiData.bank) newErrors.bank = "Branch name is required.";
    if (!apiData.email) newErrors.email = "Email is required.";
    if (!apiData.phone) newErrors.phone = "Mobile number is required.";
    if (!apiData.address) newErrors.address = "Address is required.";
    if (!apiData.city) newErrors.city = "City is required.";
    if (!apiData.state) newErrors.state = "State is required.";
    if (!apiData.username) newErrors.username = "Username is required.";
    if (!apiData.password) newErrors.password = "Password is required.";
    if (!apiData.pincode) newErrors.pincode = "Pincode is required.";
    if (!isValidEmail(apiData.email))
      newErrors.email = "Please Enter Valid Email.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // If no errors, return true
  };

  // Update available cities when state changes
  useEffect(() => {
    if (apiData.state && stateCityData[apiData.state]) {
      setAvailableCities(stateCityData[apiData.state]);
      // If current city is not in the new state's cities, clear it
      if (apiData.city && !stateCityData[apiData.state].includes(apiData.city)) {
        setApiData((prev) => ({ ...prev, city: "" }));
      }
    } else {
      setAvailableCities([]);
    }
  }, [apiData.state, apiData.city]);

  return (
    <div className={style["container"]}>
      <h1>Add Partner Details</h1>
      <div className={style["wrap-inp"]}>
        <div className={style["inp-container"]}>
          <label htmlFor="contactPerson">
            Partner's Name<span>*</span>
          </label>
          <Input
            value={apiData.contactPerson}
            onChange={(e) => {
              setApiData({
                ...apiData,
                contactPerson: AllowInputType(e.target.value, "string"),
              });
            }}
            name="contactPerson"
            className={errors.contactPerson ? style["error-border"] : ""}
          />
          <div>{errors.contactPerson}</div>
        </div>
        <div className={style["inp-container"]}>
          <label htmlFor="companyName">
            Company Name<span>*</span>
          </label>
          <Input
            value={apiData.name}
            onChange={(e) => {
              setApiData({
                ...apiData,
                name: AllowInputType(e.target.value, "string"),
              });
            }}
            name="companyName"
            className={errors.name ? style["error-border"] : ""}
          />
        </div>
      </div>
      <div className={style["wrap-inp"]}>
        <div className={style["inp-container"]}>
          <label htmlFor="bankAccountNumber">
            Bank Account Number<span>*</span>
          </label>

          <Input
            value={apiData.accountNumber}
            onChange={(e) => {
              setApiData({
                ...apiData,
                accountNumber: AllowInputType(e.target.value, "numeric"),
              });
            }}
            name="bankAccountNumber"
            className={errors.accountNumber ? style["error-border"] : ""}
          />
        </div>
        <div className={style["inp-container"]}>
          <label htmlFor="IFSCCode">
            IFSC Code<span>*</span>
          </label>
          <Input
            value={apiData.ifsc}
            onChange={(e) => {
              setApiData({
                ...apiData,
                ifsc: AllowInputType(e.target.value, "alphanumeric"),
              });
            }}
            name="IFSCCode"
            className={errors.ifsc ? style["error-border"] : ""}
          />
        </div>
      </div>

      <div className={style["wrap-inp"]}>
        <div className={style["inp-container"]}>
          <label htmlFor="branchName">
            Branch Name<span>*</span>
          </label>
          <Input
            value={apiData.bank}
            onChange={(e) => {
              setApiData({
                ...apiData,
                bank: AllowInputType(e.target.value, "alphanumeric"),
              });
            }}
            name="branchName"
            className={errors.bank ? style["error-border"] : ""}
          />
        </div>

        <div className={style["inp-container"]}>
          <label htmlFor="email">
            Email<span>*</span>
          </label>
          <Input
            value={apiData.email}
            onChange={(e) => {
              setApiData({
                ...apiData,
                email: e.target.value,
              });
            }}
            name="email"
            className={errors.email ? style["error-border"] : ""}
          />
        </div>
      </div>

      <div className={style["wrap-inp"]}>
        <div className={style["inp-container"]}>
          <label htmlFor="mobileNo">
            Mobile no<span>*</span>
          </label>
          <Input
            value={apiData.phone}
            onChange={(e) => {
              setApiData({
                ...apiData,
                phone: AllowInputType(e.target.value, "numeric"),
              });
            }}
            maxLength={10}
            name="mobileNo"
            className={errors.phone ? style["error-border"] : ""}
          />
        </div>
        <div className={style["inp-container"]}>
          <label htmlFor="address">
            Address<span>*</span>
          </label>
          <Input
            value={apiData.address}
            onChange={(e) => {
              setApiData({
                ...apiData,
                address: AllowInputType(e.target.value, "alphanumeric"),
              });
            }}
            name="address"
            className={errors.address ? style["error-border"] : ""}
          />
        </div>
      </div>
      <div className={style["wrap-inp"]}>
        <div className={style["inp-container"]}>
          <label htmlFor="state">
            State<span>*</span>
          </label>
          <Select
            value={apiData.state || undefined}
            onChange={(value) => {
              setApiData({
                ...apiData,
                state: value,
                city: "", // Clear city when state changes
              });
            }}
            placeholder="Select State"
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={states.map((state) => ({
              label: state,
              value: state,
            }))}
            status={errors.state ? "error" : undefined}
            style={{ width: "100%" }}
          />
          {errors.state && <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.state}</div>}
        </div>
        <div className={style["inp-container"]}>
          <label htmlFor="city">
            City<span>*</span>
          </label>
          <Select
            value={apiData.city || undefined}
            onChange={(value) => {
              setApiData({
                ...apiData,
                city: value,
              });
            }}
            placeholder="Select City"
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={availableCities.map((city) => ({
              label: city,
              value: city,
            }))}
            disabled={!apiData.state || availableCities.length === 0}
            status={errors.city ? "error" : undefined}
            style={{ width: "100%" }}
          />
          {errors.city && <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.city}</div>}
        </div>
      </div>
      <div className={style["wrap-inp"]}>
        <div className={style["inp-container"]}>
          <label htmlFor="pincode">
            User Name<span>*</span>
          </label>
          <Input
            value={apiData.username}
            onChange={(e) => {
              setApiData({
                ...apiData,
                username: e.target.value,
              });
            }}
            name="username"
            className={errors.username ? style["error-border"] : ""}
          />
        </div>
        <div className={style["inp-container"]}>
          <label htmlFor="pincode">
            Password<span>*</span>
          </label>
          <Input
            type="password"
            value={apiData.password}
            onChange={(e) => {
              setApiData({
                ...apiData,
                password: e.target.value,
              });
            }}
            name="password"
            className={errors.password ? style["error-border"] : ""}
          />
        </div>
      </div>
      <div className={style["wrap-inp"]}>
        <div className={style["inp-container"]}>
          <label htmlFor="pincode">
            Pincode<span>*</span>
          </label>
          <Input
            value={apiData.pincode}
            onChange={(e) => {
              setApiData({
                ...apiData,
                pincode: Number(AllowInputType(e.target.value, "numeric")),
              });
            }}
            name="pincode"
            className={errors.pincode ? style["error-border"] : ""}
          />
        </div>
        <div
          className={style["inp-container"]}
          style={{ display: "flex", alignItems: "center" }}
        >
          <div style={{ marginRight: "16px" }}>disable</div>
          <Switch
            value={apiData.disabled}
            onChange={(checked) =>
              setApiData({ ...apiData, disabled: checked })
            }
          />
        </div>
      </div>
      <div className={btnStyle["wrap-submit-cancel"]}>
        <CommonButton color="green" onClick={() => savePartner()}>
          Save
        </CommonButton>
        <CommonButton color="secondary" onClick={() => setMode(MODE.HOME)}>
          Cancel
        </CommonButton>
      </div>
    </div>
  );
}

function Partners() {
  const [mode, setMode] = useState(MODE.HOME as MODE);
  const [partnerData, setPartnerData] = useState(
    [] as CreatePartnerInterface[]
  );
  const [selectedPartnerData, setSelectedPartnerData] = useState(
    {} as CreatePartnerInterface
  );
  const [originalData, setOriginalData] = useState<any[]>([]);

  const onEdit = (record: CreatePartnerInterface) => {
    setSelectedPartnerData(record);
    setMode(MODE.EDIT_PARTNER);
  };

  const onCreate = () => {
    setMode(MODE.CREATE_PARTNER);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _onDelete = async (record: CreatePartnerInterface) => {
    const partner = await API.admin.DeletePartner(record._id);

    if (!API.validators.checkSuccessCode(partner)) {
      return message.error("unable to delete partner");
    }

    message.success("partner successfully deleted");
    getList();
  };

  const getList = async () => {
    const partners = await API.admin.GetPartners();
    if (!API.validators.checkSuccessCode(partners)) {
      return message.error("unable to fetch the partners list");
    }
    setPartnerData(partners.data?.data);
    setOriginalData(partners.data?.data);
  };

  useEffect(() => {
    getList();
  }, [mode]);

  const columns: TableProps<CreatePartnerInterface>["columns"] = [
    {
      title: "Partner Name",
      dataIndex: "contactPerson",
      key: "contactPerson",
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      render: (text: any) => <a>{text}</a>,
    },

    {
      title: "Company Name",
      dataIndex: "name",
      key: "name",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a onClick={() => onEdit(record)}>Edit</a>
          {/* <a onClick={() => _onDelete(record)}>Delete</a> */}
        </Space>
      ),
    },
  ];

  return (
    <div>
      {mode === "home" && (
        <div>
          <div className={style["warp-search-inp"]}>
            <SearchFeature
              originalData={originalData}
              setData={setPartnerData}
              keyData="contactPerson"
              placeholder="Search Partner Name"
            />
            <CommonButton color="primary" onClick={() => onCreate()}>
              Create Partner
            </CommonButton>
          </div>

          <CommonTable
            columns={columns}
            data={partnerData.map((item) => {
              return { ...item, key: item._id };
            })}
            expandable={{
              expandedRowRender: (record: CreatePartnerInterface) => (
                <PartnerHubs id={record._id} />
              ),
            }}
          />
        </div>
      )}
      {mode === MODE.CREATE_PARTNER && (
        <CreateEditParnter
          mode={MODE.CREATE_PARTNER}
          setMode={setMode}
          data={selectedPartnerData}
        />
      )}
      {mode === MODE.EDIT_PARTNER && (
        <CreateEditParnter
          mode={MODE.EDIT_PARTNER}
          setMode={setMode}
          data={selectedPartnerData}
        />
      )}
    </div>
  );
}

export default Partners;
